/**
 * Shared "new design" backdrop — a faint blueprint grid + a top signal-yellow
 * glow. Drop it as the first child inside a dark page wrapper to unify every
 * page with the homepage / platform editorial look. Fixed + pointer-events:none
 * so it never interferes with the page's content or interactions.
 */
export default function PageAtmosphere() {
  return (
    <>
      <div aria-hidden style={{
        position: 'fixed', inset: 0, zIndex: 0, pointerEvents: 'none', opacity: 0.4,
        backgroundImage: 'linear-gradient(var(--c-border) 1px,transparent 1px),linear-gradient(90deg,var(--c-border) 1px,transparent 1px)',
        backgroundSize: '60px 60px',
        WebkitMaskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, #000, transparent 75%)',
        maskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, #000, transparent 75%)',
      }} />
      <div aria-hidden style={{
        position: 'fixed', inset: '-10% 0 auto 0', height: '52vh', zIndex: 0, pointerEvents: 'none',
        background: 'radial-gradient(55% 50% at 50% 0%, color-mix(in srgb, var(--accent) 10%, transparent), transparent 70%)',
      }} />
    </>
  );
}
